import React, { FunctionComponent } from 'react';
import Slider from 'react-slick';
import type { PresentationProps as Props } from './types';

const mobileSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite: true,
  centerMode: true,
  centerPadding: '10%',
  dots: true,
  draggable: true,
  swipe: true,
};

export const Presentation: FunctionComponent<Props> = ({ events, isMobile, noimage }) => {
  const items = events.map((e, i) => (
    <div
      key={e.id}
      className="sitetop-recruitment-container-link gtm-event-view-count"
      data-event-name="event on screen"
      data-category="topcontent"
      data-value={`hot_event${i + 1}`}
      data-eventid={e.id}
      data-companyid={e.companyId}
    >
      <div className="sitetop-recruitment-container-box">
        <div className="sitetop-recruitment-container-box-inner">
          <a
            href={`/events/${e.id}`}
            data-event="click"
            data-category="topcontent"
            data-value={`hot_event${i + 1}`}
            data-click-point="image"
            data-eventid={e.id}
            data-companyid={e.companyId}
          >
            {e.image ? (
              <div
                style={{ backgroundImage: `url(${e.image})` }}
                className="sitetop-recruitment-container-box-inner-img-bg"
              />
            ) : (
              <img
                src={noimage}
                alt={`${e.title}のカバー写真`}
                className="sitetop-recruitment-container-box-img"
              />
            )}
          </a>

          <div className="sitetop-recruitment-container-box-inner-bottom">
            <a
              href={`/events/${e.id}`}
              data-event="click"
              data-category="topcontent"
              data-value={`hot_event${i + 1}`}
              data-click-point="title"
              data-eventid={e.id}
              data-companyid={e.companyId}
            >
              <div className="sitetop-recruitment-container-box-title">
                {e.title}
              </div>
              <div className="sitetop-recruitment-container-box-occupation">
                <time className="sitetop-recruitment-container-box-occupation-word">
                  {e.dates}
                </time>
              </div>
            </a>

            <div className="sitetop-recruitment-container-box-company">
              <a
                href={`/companies/${e.companyId}`}
                data-event="click"
                data-category="topcontent"
                data-value={`hot_event${i + 1}`}
                data-click-point="company"
                data-eventid={e.id}
                data-companyid={e.companyId}
              >
                <span className="sitetop-recruitment-container-box-company-icon">
                  <img
                    src={e.companyIcon}
                    alt={`${e.companyName}のロゴ写真`}
                    className="sitetop-recruitment-container-box-company-icon-img"
                  />
                </span>
              </a>
              <a
                href={`/companies/${e.companyId}`}
                className="sitetop-recruitment-container-box-company-name"
                data-event="click"
                data-category="topcontent"
                data-value={`hot_event${i + 1}`}
                data-click-point="company"
                data-eventid={e.id}
                data-companyid={e.companyId}
              >
                {e.companyName}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  ));

  return (
    <section className="sitetop-recruitment" id="hot_events">
      <div className="sitetop-pickup-nav">
        <h2 className="sitetop-pickup-title">
          HOT EVENT<span className="sitetop-pickup-sub">開催日が近いおすすめイベント</span>
        </h2>
        <a
          href="/events"
          className="sitetop-pickup-companies gtm-button-view-count"
          data-event-name="button on screen"
          data-event="click"
          data-category="topcontent"
          data-value="hot_event_to_all"
        >
          イベント一覧へ
        </a>
      </div>

      <div className="sitetop-recruitment-container">
        {isMobile ? (
          <Slider {...mobileSettings} className="sitetop-recruitment-container-inner">
            {items}
          </Slider>
        ) : (
          items
        )}
      </div>

      <a
        href="/events"
        className="sitetop-pickup-spcompanies gtm-button-view-count"
        data-event="click"
        data-category="topcontent"
        data-value="hot_event_to_all"
      >
        イベント一覧へ
      </a>
    </section>
  );
};
